export const FLIP_COUNTER_CONFIG = {
  DEFAULT_TOTAL_FRAMES: 60, // Default total frames for the entire counter animation
  DEFAULT_FONT_SIZE: 120, // Default font size in pixels
  SETTLE_SPRING: { damping: 12, stiffness: 120, mass: 0.5 }, // Spring configuration for settle bounce
  SETTLE_SCALE: { max: 1.15, duration: 0.15 }, // Settle bounce scale range
} as const;

export const TEXT_FILL_ANIMATION = {
  FILL_DURATION: 30, // Frames for fill transition
} as const;

/** Shadow opacity during flip */
export const FLIP_SHADOW_OPACITY = 0.5;
